export const enum BannerTheme {
  dark = 'dark',
  white = 'white',
  offwhite = 'offwhite',
}
